import service from "@/utils/request";
// 获取省市区列表
export let getarealistAPI = () => {
  return service.post(`common/arealist`);
}

// 获取配送列表
export let deliverylistAPI = () => {
  return service.post(`shop/allpeisong`);
}

///index/index/getBaojia
//获取价格
export const getBaojia = (parm) => {
  return service.post(`index/getBaojia`, parm);
}